import {ChangeDetectionStrategy, ChangeDetectorRef, Component, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FormArray} from "@angular/forms";
import {SpørreundersøkelseSpørsmålSkjemaKomponent, SpørsmålSkjemaType, SpørsmålSvarSpesifikasjon, ValgtittelPlassering} from "../spørreundersøkelse-spørsmål-skjema/spørreundersøkelse-spørsmål-skjema";
import {SpørreskjemaModell, SpørreundersøkelseModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {erSpørsmålSomKanBesvares, spørsmålHarSammeTypeOgOppsett} from "felles-ng2/modell/spørreundersøkelseModellhjelpere";
import {oppdaterGuiVedEndringIFormArrayLengde} from "felles-ng2/infrastruktur/angular/reactiveForm";

const debug = initDebugger('SpørreundersøkelseBesvarelseSkjemaKomponent');
export type SpørsmålsamlingSkjemaType = ReturnType<typeof SpørreundersøkelseBesvarelseSkjemaKomponent.opprettSkjema>;
export type SpørsmålsamlingSkjemaVerdier = SpørsmålsamlingSkjemaType['value'];


/**
 * Skjema for besvarelse av spørreundersøkelse
 */
@Component({
    selector: 'spoerreundersoekelse-besvarelse-skjema',
    templateUrl: 'spørreundersøkelse-besvarelse-skjema.html',
    styleUrl: 'spørreundersøkelse-besvarelse-skjema.scss',
    imports: [
        SpørreundersøkelseSpørsmålSkjemaKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpørreundersøkelseBesvarelseSkjemaKomponent {

    static opprettSkjema() {
        return new FormArray<SpørsmålSkjemaType>([]);
    }

    /** Returnerer SpørsmålsamlingSkjemaType populert med angitt skjema og med alle skjemakontroller deaktivert slik at skjemaet ikke kan redigeres */
    static opprettIkkeRedigerbartSkjema(skjema: SpørreskjemaModell) {
        const undersøkelseSkjema = SpørreundersøkelseBesvarelseSkjemaKomponent.opprettSkjema();
        SpørreundersøkelseBesvarelseSkjemaKomponent.populerSkjema(undersøkelseSkjema, {skjema: skjema});
        undersøkelseSkjema.disable();
        return undersøkelseSkjema;
    }

    static populerSkjema(skjema: SpørsmålsamlingSkjemaType, spørreundersøkelse: Pick<SpørreundersøkelseModell, 'skjema'>) {
        skjema.clear();
        spørreundersøkelse.skjema.spoersmaal
          .map(spørsmål => SpørreundersøkelseSpørsmålSkjemaKomponent.opprettSkjema(spørsmål))
          .forEach(spørsmålskjema => skjema.push(spørsmålskjema));
    }

    static somSpesifikasjon(skjema: SpørsmålsamlingSkjemaVerdier): SpørsmålSvarSpesifikasjon[] {
        return skjema
          .filter(spørsmålsrad => erSpørsmålSomKanBesvares(spørsmålsrad.spoersmaal!))
          .map(spørsmålsrad => SpørreundersøkelseSpørsmålSkjemaKomponent.somSpesifikasjon(spørsmålsrad));
    }

    skjemakontroll = input.required<SpørsmålsamlingSkjemaType>();

    constructor(private cdRef: ChangeDetectorRef) {
        //FormArray.push (og øvrige metoder på FormArray) trigger ikke rendering - må derfor manuelt signalisere at det har skjedd endringer som skal tegnes ut
        oppdaterGuiVedEndringIFormArrayLengde(this.skjemakontroll, this.cdRef);
    }

    visValgtittel(indeks: number): boolean {
        const aktueltSpørsmål = this.skjemakontroll().at(indeks);
        const sammeSomForrige = indeks > 0 ? spørsmålHarSammeTypeOgOppsett(aktueltSpørsmål.value.spoersmaal, this.skjemakontroll().at(indeks - 1).value.spoersmaal) : false;
        return !sammeSomForrige;
    }

    radioknappTittelplassering(indeks: number): ValgtittelPlassering {
        const aktueltSpørsmål = this.skjemakontroll().at(indeks);
        const sammeSomNeste = indeks < this.skjemakontroll().length - 1 ? spørsmålHarSammeTypeOgOppsett(aktueltSpørsmål.value.spoersmaal, this.skjemakontroll().at(indeks + 1).value.spoersmaal) : false;
        if (sammeSomNeste) return 'over';
        return 'under';
    }
}
